import { render, staticRenderFns } from "./BfHeader.vue?vue&type=template&id=de2e361c&scoped=true&"
import script from "./BfHeader.vue?vue&type=script&lang=js&"
export * from "./BfHeader.vue?vue&type=script&lang=js&"
import style0 from "./BfHeader.vue?vue&type=style&index=0&id=de2e361c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2e361c",
  null
  
)

export default component.exports